export interface Differentiator {
  title: string;
  blurb: string;
  accent: "gold" | "cyan" | "green" | "red";
}

export const DIFFERENTIATORS: Differentiator[] = [
  {
    title: "Provably fair",
    blurb:
      "SHA-256 commit before play, seed revealed after. The @vb/engine module ships to the client and verifies every round in the browser.",
    accent: "green",
  },
  {
    title: "Published math",
    blurb:
      "1–5% house edge per game, derived from each game's published payout formula. Invariant to player strategy. Engine source, RTP formulas, and test suite are shared with every operator.",
    accent: "gold",
  },
  {
    title: "Thin integration",
    blurb:
      "Six REST endpoints, one WebSocket stream. Operators build the adapter in roughly a week. Full curl contract and Zod schemas in the docs.",
    accent: "cyan",
  },
  {
    title: "No player custody",
    blurb:
      "We never touch player funds. Your wallet is the source of truth — we call into it via launch-token handshake and debit/credit. No FX, no KYC leakage.",
    accent: "cyan",
  },
];
